import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function FlashSaleBar() {
  const {
    formattedTime,
    minutes,
    seconds
  } = useCountdown(undefined, 900); // 15 minutes
  const isUrgent = minutes < 5;
  const isCritical = minutes < 2;
  return <div className="bg-[#1A1035] text-white p-[10px] flex justify-between items-center sticky top-0 z-[1001] shadow-md" data-id="element-114">
      <span className="font-bold text-[11px] sm:text-[13px] tracking-wide" data-id="element-115">
        💜 OFERTA ESPECIAL: SOLO POR HOY ➤
      </span>
      <div className={`text-[13px] font-[900] px-[12px] py-[5px] rounded-[4px] tracking-[1px] transition-colors duration-300 ${isCritical ? 'bg-[#DC2626] text-white animate-pulse shadow-[0_0_12px_rgba(220,38,38,0.6)]' : isUrgent ? 'bg-[#F59E0B] text-[#1A1035]' : 'bg-[#D4A017] text-[#1A1035]'}`} style={{
      minWidth: '70px',
      textAlign: 'center'
    }} data-id="element-116">
        ⏱ {formattedTime}
      </div>
      <a href="#elige-tu-plan" className="bg-[#F8F6FF] text-[#1A1035] no-underline font-[900] rounded-[4px] text-[10px] sm:text-[12px] uppercase hover:bg-white transition-colors" style={{
      paddingLeft: '14px',
      paddingRight: '14px',
      paddingTop: '8px',
      paddingBottom: '8px',
      fontWeight: '700'
    }} data-id="element-117">
        OBTENER AHORA
      </a>
    </div>;
}